import React, {useEffect, useRef, useState} from 'react';
import {ContainerTitleTable} from "../../components/Containers/ContainerTitleTable";
import {UsePermissions} from "../../hooks/usePermissions";
import {ContainerTable} from "../../components/Containers/ContainerTable";
import {UseLoader} from "../../hooks/useLoader";


import {Toast} from "primereact/toast";
import {AutoComplete} from "primereact/autocomplete";
import {ContainerGroupForm} from "../../components/Containers/ContainerGroupForm";

import {
    aplicarCuotaDeta,
    deduccionInfo, deduccionSyP, editarCuotaDeta,
    getAsociados,
    liquidacionInfo, obtenerAnioLiquidacionesPorCliente,
    obtenerLiquidacionesPorCliente, obtenerLiquidacionesPorClientePost, obtenerMesLiquidacionesPorCliente
} from "../../api/liquidacionDeduccion.service";

import {DescripcionCompe} from "./components/DescripcionCompe";
import {FormDeducciones} from "./components/FormDeducciones";
import {TableDeduccionesAsociados} from "./components/TableDeduccionesAsociados";
import {TabPanel, TabView} from "primereact/tabview";

import {TableDeduccionesTotal} from "./components/TableDeduccionesTotal";
import {ModalEditarDeduccionIndi} from "./components/ModalEditarDeduccionIndi";
import {confirmDialog} from "primereact/confirmdialog";


export const LiquidacionDeduccionPage = () => {
    const [permisos] = UsePermissions();
    const [handleLoad] = UseLoader();
    const toast = useRef(null);
    const [clientes, setClientes] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const [selectedcliente, setSelectedcliente] = useState({
        nombre: "",
        id: ""
    });
    const [FilteredCliente, setFilteredCliente] = useState(null);
    const [fechaLiquidaciones, setFechaLiquidaciones] = useState([]);
    const [anioLiquidaciones, setAnioLiquidaciones] = useState([]);
    const [mesLiquidaciones, setMesLiquidaciones] = useState([]);
    const [dataLiquidacion, setDataLiquidacion] = useState([]);
    const [dataLiquidacionTotal, setDataLiquidacionTotal] = useState([]);
    const [fieldEdit, setFieldEdit] = useState({});
    const [reload, setReload] = useState(false);
    const [displayNewModal, setDisplayNewModal] = useState(false);
    const [disponible, setDisponible] = useState(null);
    const initParams = {
        cliente_id: '',
        fecha: '',
        anio: '',
        mes: ''
    };
    const [field, setField] = useState(initParams);

    const [filtrar, setFiltrar] = useState('N');

    const [isClean, setIsClean] = useState(false);

    useEffect(() => {
        getAsociados().then(r => {
            if (r.estado !== 200) {
                return;
            }
            setClientes(r.data)
        }).catch(r => console.log(r))
        return () => {
            if (clientes.length > 0) {
                setClientes([]);
            }
        };
    }, []);

    const onChangeFecha = e => {
        setMesLiquidaciones([]);
        setField({...field, fecha: e.target.value, anio: ''})

        if (field.cliente_id === "" || e.target.value === '') {
            setAnioLiquidaciones([]);
            toast.current?.show({severity: 'error', summary: 'Alerta', detail: "Validar campos", life: 3000});
            return;
        }
        handleLoad(true)

        const payload = {
            cliente_id: field.cliente_id,
            fecha: e.target.value
        }
        obtenerAnioLiquidacionesPorCliente(payload).then(r => {
            handleLoad(false)
            if (r.estado !== 200) {
                setAnioLiquidaciones([]);
                setMesLiquidaciones([]);
                toast.current?.show({severity: 'error', summary: 'Alerta', detail: r.mensaje, life: 3000});
                return;

            }
            setAnioLiquidaciones(r.data)
        })
    }

    const onChangeAnio = e => {

        setField({...field, anio: e.target.value})

        if (field.cliente_id === "" || field.fecha === '' || e.target.value === '') {
            setMesLiquidaciones([]);
            toast.current?.show({severity: 'error', summary: 'Alerta', detail: "Validar campos", life: 3000});
            return;
        }
        handleLoad(true)
        const payload = {
            cliente_id: field.cliente_id,
            fecha: field.fecha,
            anio: e.target.value
        }
        obtenerMesLiquidacionesPorCliente(payload).then(r => {
            handleLoad(false)
            if (r.estado !== 200) {
                setMesLiquidaciones([]);
                toast.current?.show({severity: 'error', summary: 'Alerta', detail: r.mensaje, life: 3000});
                return;

            }
            setMesLiquidaciones(r.data)
        })

    }


    const changeDate = (e) => {

        const fechas = e.target.value;
        fechaLiquidaciones.map((obj) => {
            if (obj.fecha === fechas) {
                setField({...field, fecha: fechas, anio: obj.anio, mes: obj.mes});
            }
        })
    }
     useEffect(() => {
         if (field.cliente_id !== '') {
             buscarLiquidacionesTotales();
         }
     }, [filtrar]);


    const traerFechaLiquidacion = (id) => {
        setField({...field, cliente_id: id, fecha: ''})
        setMesLiquidaciones([]);
        setAnioLiquidaciones([]);
        obtenerLiquidacionesPorCliente(id, 'S').then(r => {
            if (r.estado !== 200) {
                setFechaLiquidaciones([]);
                toast.current?.show({severity: 'error', summary: 'Alerta', detail: r.mensaje, life: 3000});
                return;

            }
            setFechaLiquidaciones(r.data)
            setMesLiquidaciones([]);
            setAnioLiquidaciones([]);
        }).catch(r => console.log(r))

    }
    const searchCliente = (event) => {
        setTimeout(() => {
            let _filteredCliente;
            if (!event.query.trim().length) {
                _filteredCliente = [...clientes];
            } else {
                _filteredCliente = clientes.filter((cliente) => {
                    return cliente.nombre.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }

            setFilteredCliente(_filteredCliente);
        }, 250);
    }
    const itemTemplate = (item) => {
        return (
            <div className="flex ">
                <div className="ml-3">{item.nombre}</div>
            </div>
        );
    }


    const reloadLiquA = () => {
        if (field.cliente_id === "" || field.fecha === '' || field.anio === '' || field.mes === '') {
            toast.current?.show({severity: 'error', summary: 'Alerta', detail: "Validar campos", life: 3000});
            return;
        }
        handleLoad(true)

        liquidacionInfo(field).then(r => {
            handleLoad(false)
            if (r.estado !== 200) {
                setDataLiquidacion([]);
                toast.current?.show({severity: 'error', summary: 'Alerta', detail: r.mensaje, life: 3000});
                return;

            }
            if (r.data.length > 0) {
                setDisponible(Math.round(Number(r.data[0].disponible)) + Math.round(Number(r.data[0].total_fondos)) - Number(r.data[0].total_deducciones));
            }

            setDataLiquidacion(r.data);
        }).catch(r => handleLoad(false))
    }

    const reloadTotal = () => {
        if (field.cliente_id === "") {
            toast.current?.show({severity: 'error', summary: 'Alerta', detail: "El afiliado es requrido", life: 3000});
            return;
        }

        handleLoad(true)
        deduccionInfo({...field, filtrar}).then(r => {
            handleLoad(false)
            if (r.estado !== 200) {
                setDataLiquidacionTotal([]);
                toast.current?.show({severity: 'error', summary: 'Alerta', detail: r.mensaje, life: 3000});
                return;

            }

            setDataLiquidacionTotal(r.data)
        }).catch(r => handleLoad(false));
    }

    const buscarLiquidaciones = (e) => {
        e.preventDefault();
        setActiveIndex(0);
        reloadLiquA();
    }

    const buscarLiquidacionesTotales = () => {
        setActiveIndex(1);
        reloadTotal()
    }

    const editarDeduccion = (e) => {
        setFieldEdit({...e});
        setDisplayNewModal(true);
    }

    const onHide = () => {
        if (field.cliente_id !== "") {
            reloadTotal();
            if (field.fecha !== '') {
                reloadLiquA();
            }
        }

        setDisplayNewModal(false);
        setReload(true);
        resetLoad();
    }

    const resetLoad = () => {
        setTimeout(() => {
            setReload(false);
        }, 2000)
    }

    const aplicarCuota = (data) => {

        try {
            if (data.estado !== 'C') {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Alerta',
                    detail: 'La cuota ya se encuentra pagada',
                    life: 3000
                });
                return;
            }

            if (Number(data.valor_cuota) > Number(Math.round(disponible))) {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Alerta',
                    detail: 'La cuota es mayor al disponible',
                    life: 3000
                });
                return;
            }

            confirmDialog({
                message: 'Se realizará la deducción',
                header: '¿Estas seguro?',
                acceptLabel: "Si",
                rejectLabel: "No",
                accept: async () => {
                    handleLoad(true)
                    const response = await aplicarCuotaDeta({...data, asociado: selectedcliente.id, ...field});
                    handleLoad(false)
                    if (response.estado !== 200) {
                        toast.current?.show({
                            severity: 'error',
                            summary: 'Alerta',
                            detail: response.mensaje,
                            life: 3000
                        });
                        return;
                    }

                    toast.current?.show({severity: 'success', summary: 'Exito', detail: response.mensaje, life: 3000});
                    reloadLiquA();
                    reloadTotal()
                }
            });

        } catch (e) {
            handleLoad(false)
        }
    }

    const editarCuota = (data) => {
        try {
            if (data.estado !== 'C') {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Alerta',
                    detail: 'La cuota ya se encuentra pagada',
                    life: 3000
                });
                return;
            }

            if (Number(data.valor_cuota) > Math.round(Number(disponible))) {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Alerta',
                    detail: 'La cuota es mayor al disponible',
                    life: 3000
                });
                return;
            }

            confirmDialog({
                message: 'Se realizará la deducción.',
                header: '¿Estas seguro?',
                acceptLabel: "Si",
                rejectLabel: "No",
                accept: async () => {
                    handleLoad(true)
                    const response = await editarCuotaDeta({...data, asociado: selectedcliente.id, ...field});
                    handleLoad(false)
                    if (response.estado !== 200) {
                        toast.current?.show({
                            severity: 'error',
                            summary: 'Alerta',
                            detail: response.mensaje,
                            life: 3000
                        });
                        return;
                    }

                    toast.current?.show({severity: 'success', summary: 'Exito', detail: response.mensaje, life: 3000});
                    setIsClean(true)
                    reloadTotal()
                    reloadLiquA();
                    setTimeout(() => {
                        setIsClean(false)
                    }, 2000)
                }
            });

        } catch (e) {
            handleLoad(false)
        }
    }

    const generarSyP = () => {
        if (field.cliente_id === "" || field.fecha === '' || field.mes === '' || field.anio === '') {
            toast.current?.show({severity: 'error', summary: 'Alerta', detail: "Validar campos", life: 3000});
            return;
        }
        try {
            confirmDialog({
                message: 'Se creará la deducción de salud y pension para el afiliado',
                header: '¿Estas seguro?',
                acceptLabel: "Si",
                rejectLabel: "No",
                accept: async () => {
                    handleLoad(true)
                    const response = await deduccionSyP(field);
                    handleLoad(false)
                    if (response.estado !== 200) {
                        toast.current?.show({
                            severity: 'error',
                            summary: 'Alerta',
                            detail: response.mensaje,
                            life: 3000
                        });
                        return;
                    }

                    toast.current?.show({severity: 'success', summary: 'Exito', detail: response.mensaje, life: 3000});
                    reloadLiquA();
                }
            });
        } catch (e) {
            handleLoad(false)
        }
    }


    const confirm = () => {
        confirmDialog({
            message: 'Filtrar solo pendientes',
            header: 'confirmacion',
            acceptLabel: "Si",
            rejectLabel: "No",
            accept: () => acceptFunc(),
            reject: () => rejectFunc()
        });
    }


    const acceptFunc = () => {
        if (filtrar === 'S') {
            buscarLiquidacionesTotales();
        } else {
            setFiltrar('S')
        }
    }

    const rejectFunc = () => {
        if (filtrar === 'N') {
            buscarLiquidacionesTotales();
        } else {
            setFiltrar('N')
        }
    }

    return (
        <div className="container-relative">
            <Toast ref={toast}/>
            <ContainerTitleTable>
                {permisos.submenu}
            </ContainerTitleTable>
            <ContainerTable>
                <div className="px-2">
                    <div className=" flex flex-wrap items-center  p-4 primary-color">
                        <div className=" mt-2 relative w-full px-4">
                            <form onSubmit={buscarLiquidaciones}>
                                <div className="row w-full">
                                    {permisos.consultar === 1 && clientes.length > 0 ?
                                        <ContainerGroupForm width="lg:w-4/12">
                                            <label
                                                className="label-form text-white"
                                                htmlFor="fecha"
                                            >
                                                Asociados *
                                            </label>
                                            <AutoComplete value={selectedcliente} suggestions={FilteredCliente}
                                                          style={{"width": "100%"}}
                                                          completeMethod={searchCliente}
                                                          placeholder="Buscador de asociados"
                                                          size="30"
                                                          field="nombre" dropdown itemTemplate={itemTemplate}
                                                          onSelect={(e) => traerFechaLiquidacion(e.value.id)}
                                                          onChange={(e) => setSelectedcliente(e.value)}/>
                                        </ContainerGroupForm>
                                        : ""}

                                    {fechaLiquidaciones.length > 0 && <ContainerGroupForm width="lg:w-2/12">
                                        <label
                                            className="label-form text-white"
                                            htmlFor="fecha"
                                        >
                                            Fecha liquidación *
                                        </label>
                                        <select value={field.fecha} name="periodo"
                                                className="form-input"
                                                onChange={(e) => onChangeFecha(e)}
                                                id="fecha">
                                            <option value="">...</option>
                                            {fechaLiquidaciones.map((p, i) => <option key={i}
                                                                                      value={p.fecha}>{p.fecha}</option>)}
                                        </select>

                                    </ContainerGroupForm>}
                                    {anioLiquidaciones.length > 0 && <ContainerGroupForm width="lg:w-2/12">
                                        <label
                                            className="label-form text-white"
                                            htmlFor="fecha"
                                        >
                                            Año *
                                        </label>
                                        <select value={field.anio} name="anio"
                                                className="form-input"
                                                onChange={(e) => onChangeAnio(e)}
                                                id="anio">
                                            <option value="">...</option>
                                            {anioLiquidaciones.map((p, i) => <option key={i}
                                                                                     value={p.anio}>{p.anio}</option>)}
                                        </select>

                                    </ContainerGroupForm>}
                                    {mesLiquidaciones.length > 0 && <ContainerGroupForm width="lg:w-1/12">
                                        <label
                                            className="label-form text-white"
                                            htmlFor="fecha"
                                        >
                                            Mes *
                                        </label>
                                        <select value={field.mes} name="periodo"
                                                className="form-input"
                                                onChange={(e) => setField({...field, mes: e.target.value})}
                                                id="fecha">
                                            <option value="">...</option>
                                            {mesLiquidaciones.map((p, i) => <option key={i}
                                                                                    value={p.mes}>{p.mes}</option>)}
                                        </select>

                                    </ContainerGroupForm>}
                                    <ContainerGroupForm width="lg:w-2/12">
                                        <div className="mt-6 relative w-full px-4">
                                            <button
                                                className="warning-color-btn btn w-full"
                                                type="submit"
                                            >
                                                Buscar x fecha
                                            </button>
                                        </div>

                                    </ContainerGroupForm>
                                    <ContainerGroupForm width="lg:w-3/12">
                                        <div className="mt-6 relative w-full px-4">
                                            <button
                                                onClick={confirm}
                                                className="warning-color-btn btn w-full"
                                                type="button"
                                            >
                                                Total deducciones
                                            </button>
                                        </div>


                                    </ContainerGroupForm>
                                </div>
                                <div className={'row'}>


                                </div>
                            </form>
                        </div>

                    </div>
                    {dataLiquidacion.length > 0 && <div className=" lg:w-8/12 mt-3 px-4">
                        <div className="container-relative">
                            <DescripcionCompe fields={dataLiquidacion}/>
                        </div>
                    </div>}
                    <div className="flex flex-wrap">
                        {selectedcliente.id !== '' && <div className="w-full lg:w-4/12 px-4">
                            <div className="container-relative">
                                <FormDeducciones generarSyP={generarSyP} fields={dataLiquidacion}
                                                 asociado_id={selectedcliente.id}
                                                 reload={onHide}/>
                            </div>
                        </div>}
                        <div className="w-full lg:w-8/12 px-4">
                            <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                                <TabPanel header="Deducciones aplicadas">
                                    {dataLiquidacion.length > 0 &&
                                        <TableDeduccionesAsociados reload={onHide}
                                                                   deducciones={dataLiquidacion[0].deducciones}
                                                                   fecha={field.fecha}/>}
                                </TabPanel>
                                <TabPanel header="Deducciones totales">
                                    {dataLiquidacionTotal.length > 0 &&
                                        <TableDeduccionesTotal
                                            cleanParams={isClean}
                                            aplicarCuota={aplicarCuota}
                                            editarCuota={editarCuota}
                                            disponible={disponible}
                                            reload={onHide}
                                            asociado={selectedcliente.id}
                                            deducciones={dataLiquidacionTotal}
                                            liquidacionId={(dataLiquidacion.length > 0 ? dataLiquidacion[0].liquidacion_id : '')}
                                            obtenerParametros={editarDeduccion}/>}
                                </TabPanel>

                            </TabView>


                        </div>

                    </div>

                </div>
                <ModalEditarDeduccionIndi show={displayNewModal} hide={onHide} liquidacion={dataLiquidacion}
                                          fields={fieldEdit}/>
            </ContainerTable>

        </div>
    );
};


